import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["employee", "month", "payslip", "amount"];
  static values = {
    payslipsData: Array
  };

  connect() {
    console.log('=== PAYMENT CONTROLLER CONNECTED ===');
    this.initializeTargets();
    
    // Initialiser les sélecteurs au chargement
    if (this.hasEmployeeTarget && this.employeeTarget.value) {
      this.updateMonths();
      if (this.hasMonthTarget && this.monthTarget.value) {
        this.updatePayslips();
      }
    }
  }

  initializeTargets() {
    console.log('Initializing targets...');
    console.log('Employee target:', this.hasEmployeeTarget);
    console.log('Month target:', this.hasMonthTarget);
    console.log('Payslip target:', this.hasPayslipTarget);
    console.log('Amount target:', this.hasAmountTarget);
    console.log('Payslips data value:', this.payslipsDataValue);
  }

  updateMonthSelect(months) {
    console.log('Updating month select with:', months);
    
    // Trouver le select des mois directement
    const monthSelect = document.querySelector('select[name="month_year"]');
    if (monthSelect) {
      console.log('Found month select:', monthSelect);
      
      // Vider le select
      monthSelect.innerHTML = `<option value="">Sélectionner un mois</option>`;
      
      // Ajouter les options
      months.forEach(month => {
        const option = document.createElement('option');
        option.value = month;
        option.textContent = month;
        monthSelect.appendChild(option);
        console.log('Added month option:', month);
      });
      
      // Activer/désactiver le select
      monthSelect.disabled = months.length === 0;
      console.log('Month select updated, disabled:', monthSelect.disabled);
      console.log('Month select options count:', monthSelect.options.length);
    } else {
      console.error('Month select not found!');
    }
  }

  updatePayslipSelect(payslips) {
    console.log('Updating payslip select with:', payslips);
    
    // Trouver le select des bulletins de paie directement
    const payslipSelect = document.querySelector('select[name="payment[payslip_id]"]');
    if (payslipSelect) {
      console.log('Found payslip select:', payslipSelect);
      
      // Vider le select
      payslipSelect.innerHTML = `<option value="">Sélectionner un bulletin de paie</option>`;
      
      // Ajouter les options
      payslips.forEach(payslip => {
        const option = document.createElement('option');
        option.value = payslip.id;
        option.textContent = payslip.description;
        option.dataset.amount = payslip.net_amount;
        payslipSelect.appendChild(option);
        console.log('Added payslip option:', payslip.description);
      });
      
      // Activer/désactiver le select
      payslipSelect.disabled = payslips.length === 0;
      console.log('Payslip select updated, disabled:', payslipSelect.disabled);
      console.log('Payslip select options count:', payslipSelect.options.length);
    } else {
      console.error('Payslip select not found!');
    }
  }

  // Quand l'employé change, mettre à jour les mois disponibles
  employeeChanged() {
    const employeeId = this.employeeTarget.value;
    console.log('Employee changed to:', employeeId);
    
    // Mettre à jour le champ caché pour l'employé (pour la logique)
    const hiddenEmployeeField = document.querySelector('input[name="employee_id"]');
    if (hiddenEmployeeField) {
      hiddenEmployeeField.value = employeeId;
      console.log('Hidden employee field updated to:', employeeId);
    }
    
    if (employeeId) {
      // Utiliser les données déjà disponibles dans le contrôleur
      console.log('Using payslips data from controller:', this.payslipsDataValue);
      
      // Filtrer les mois pour cet employé
      const employeePayslips = this.payslipsDataValue.filter(p => p.employee_id == employeeId);
      console.log('Employee payslips:', employeePayslips);
      
      // Extraire les mois uniques
      const months = [...new Set(employeePayslips.map(p => p.month_year))].sort().reverse();
      console.log('Available months:', months);
      
      this.updateMonthSelect(months);
    } else {
      // Réinitialiser le select des mois
      this.updateMonthSelect([]);
    }
  }

  // Quand le mois change, mettre à jour les bulletins disponibles
  monthChanged() {
    const employeeId = this.employeeTarget.value;
    const monthYear = this.monthTarget.value;
    console.log('Month changed to:', monthYear);
    
    // Mettre à jour le champ caché pour le mois (pour la logique)
    const hiddenMonthField = document.querySelector('input[name="month_year"]');
    if (hiddenMonthField) {
      hiddenMonthField.value = monthYear;
      console.log('Hidden month field updated to:', monthYear);
    }
    
    if (employeeId && monthYear) {
      // Utiliser les données déjà disponibles dans le contrôleur
      console.log('Using payslips data from controller:', this.payslipsDataValue);
      
      // Filtrer les bulletins pour cet employé et ce mois
      const employeePayslips = this.payslipsDataValue.filter(p => 
        p.employee_id == employeeId && p.month_year == monthYear
      );
      console.log('Filtered payslips:', employeePayslips);
      
      this.updatePayslipSelect(employeePayslips);
    } else {
      // Réinitialiser le select des bulletins de paie
      this.updatePayslipSelect([]);
    }
  }

  // Quand le bulletin change, mettre à jour le montant
  payslipChanged() {
    const payslipId = this.payslipTarget.value;
    console.log('Payslip changed to:', payslipId);
    
    // Mettre à jour le champ caché pour le payslip (pour la logique)
    const hiddenPayslipField = document.querySelector('input[name="payslip_id"]');
    if (hiddenPayslipField) {
      hiddenPayslipField.value = payslipId;
      console.log('Hidden payslip field updated to:', payslipId);
    }
    
    if (payslipId) {
      // Récupérer le montant depuis l'option sélectionnée
      const selectedOption = this.payslipTarget.querySelector(`option[value="${payslipId}"]`);
      if (selectedOption && selectedOption.dataset.amount) {
        const amount = selectedOption.dataset.amount;
        this.amountTarget.value = amount;
        console.log('Amount updated to:', amount);
        
        // Mettre à jour le champ caché du montant dans le formulaire
        const hiddenAmountField = document.querySelector('input[name="payment[amount]"]');
        if (hiddenAmountField) {
          hiddenAmountField.value = amount;
          console.log('Hidden amount field updated to:', amount);
        } else {
          console.error('Hidden amount field not found');
        }
      } else {
        console.error('Selected option not found or no amount data');
      }
    } else {
      this.amountTarget.value = '';
      console.log('Amount cleared');
      
      // Vider aussi le champ caché du montant
      const hiddenAmountField = document.querySelector('input[name="payment[amount]"]');
      if (hiddenAmountField) {
        hiddenAmountField.value = '';
        console.log('Hidden amount field cleared');
      }
    }
  }

  // Mettre à jour les mois disponibles pour l'employé sélectionné
  updateMonths() {
    const employeeId = this.employeeTarget.value;
    console.log('=== PAYMENT CONTROLLER DEBUG ===');
    console.log('Employee ID sélectionné:', employeeId);
    console.log('Payslips data disponible:', this.payslipsDataValue);
    
    this.monthTarget.innerHTML = `<option value="">${this.monthTarget.dataset.prompt}</option>`;
    this.payslipTarget.innerHTML = `<option value="">${this.payslipTarget.dataset.prompt}</option>`;
    this.payslipTarget.disabled = true;
    this.amountTarget.value = '';
    
    if (employeeId) {
      // Récupérer les mois disponibles pour cet employé
      const months = [];
      this.payslipsDataValue.forEach(payslip => {
        console.log('Vérification payslip:', payslip);
        console.log('Payslip employee_id:', payslip.employee_id, 'Type:', typeof payslip.employee_id);
        console.log('Employee ID recherché:', employeeId, 'Type:', typeof employeeId);
        
        if (payslip.employee_id == employeeId && !months.includes(payslip.month_year)) {
          months.push(payslip.month_year);
          console.log('Mois ajouté:', payslip.month_year);
        }
      });
      
      console.log('Mois trouvés pour cet employé:', months);
      
      // Trier les mois par ordre décroissant (plus récent en premier)
      months.sort().reverse();
      
      // Ajouter les options de mois
      months.forEach(month => {
        const option = new Option(month, month);
        this.monthTarget.add(option);
        console.log('Option mois ajoutée:', month);
      });
      
      // Vérifier le nombre d'options après ajout
      console.log('Nombre total d\'options dans le select:', this.monthTarget.options.length);
      console.log('Options disponibles:', Array.from(this.monthTarget.options).map(opt => opt.textContent));
      
      // Réactiver le select des mois s'il y a des options
      if (months.length > 0) {
        this.monthTarget.disabled = false;
        console.log('Select des mois réactivé');
        
        // Forcer le re-rendu du select
        this.monthTarget.style.display = 'none';
        setTimeout(() => {
          this.monthTarget.style.display = '';
          console.log('Re-rendu du select forcé');
        }, 10);
      } else {
        this.monthTarget.disabled = true;
        console.log('Aucun mois trouvé, select désactivé');
      }
    } else {
      // Désactiver le select si aucun employé n'est sélectionné
      this.monthTarget.disabled = true;
      console.log('Aucun employé sélectionné, select désactivé');
    }
    
    console.log('=== FIN PAYMENT CONTROLLER DEBUG ===');
  }

  // Mettre à jour les bulletins disponibles pour l'employé et le mois sélectionnés
  updatePayslips() {
    const employeeId = this.employeeTarget.value;
    const monthYear = this.monthTarget.value;
    this.payslipTarget.innerHTML = `<option value="">${this.payslipTarget.dataset.prompt}</option>`;
    this.payslipTarget.disabled = !monthYear;
    this.amountTarget.value = '';
    
    if (employeeId && monthYear) {
      // Filtrer les bulletins pour cet employé et ce mois
      const filteredPayslips = this.payslipsDataValue.filter(payslip => {
        return payslip.employee_id == employeeId && payslip.month_year == monthYear;
      });
      
      // Ajouter les options de bulletins
      filteredPayslips.forEach(payslip => {
        const option = document.createElement('option');
        option.value = payslip.id;
        option.textContent = payslip.description;
        option.dataset.amount = payslip.net_amount;
        this.payslipTarget.appendChild(option);
      });
    }
  }

  // Mettre à jour le montant en fonction du bulletin sélectionné
  updateAmount() {
    const payslipId = this.payslipTarget.value;
    if (payslipId) {
      const selectedOption = this.payslipTarget.querySelector(`option[value="${payslipId}"]`);
      if (selectedOption && selectedOption.dataset.amount) {
        this.amountTarget.value = selectedOption.dataset.amount;
      }
    }
  }
}